import { GridOptions } from 'ag-grid-community';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AgGridHelperService } from '../../../reusables/services/ag-grid-helper.service';
import { DashboardDTO, User } from '../user-admin.model';
import { UserAdminService } from '../user-admin.service';
import { AgGridAngular } from 'ag-grid-angular';

@Component({
    selector: 'cv-dashboards-useradmin',
    templateUrl: './dashboards-useradmin.component.html',
    styleUrls: ['./dashboards-useradmin.component.scss']
})
export class DashboardsUseradminComponent implements OnInit {
    @ViewChild('dashboardsUserAdminOwnedGrid') agGridOwned: AgGridAngular;
    @ViewChild('dashboardsUserAdminSelectedGrid') agGridSelected: AgGridAngular;
    @ViewChild('dashboardsUserAdminAssignedGrid') agGridAssigned: AgGridAngular;
    @Input() selectedUserInfo: User;
    @Input() dashboards: DashboardDTO[];
    @Input() listUsers: User[];

    public linkedDataGroupLogins: User[];
    public gridOptionsDashboards: GridOptions;
    public gridOptionsDashboardsSelected: GridOptions;
    public gridOptionsDashboardsAssign: GridOptions;
    public filterValue: string = '';
    public gridModalReady: boolean = false;
    public gridDashboardReady: boolean = false;
    public gridModalDashboardsReady: boolean = false;
    public gridModalLoginsReady: boolean = false;
    public ownershipPopupOpen = false;
    public pendingOwnershipChangeName: string;
    public changeOwnershipSuccessful: boolean = false;
    public changeOwnershipFailed: boolean = false;

    public changeOwnershipTimer: NodeJS.Timeout = null;

    constructor(
        private gridHelperService: AgGridHelperService,
        private uAService: UserAdminService
    ) { }

    ngOnInit(): void {

        this.setupAgGridDashboards();
    }

    setupAgGridDashboards() {
        this.gridOptionsDashboards = {
            columnDefs: [
                {
                    headerCheckboxSelection: true,
                    headerCheckboxSelectionFilteredOnly: true,
                    checkboxSelection: true,
                    sortable: false,
                    width: 40,
                    suppressSizeToFit: true,
                },
                {
                    field: "DashboardName",
                    colId: "DashboardName",
                    //headerName: this.sf.localizationCommon['Name'][0],
                    headerName: "Dashboard Name",
                },
                {
                    field: "DashboardGroup",
                    colId: "Folder",
                    //headerName: this.sf.localization['Type'][0],
                    headerName: "Folder",
                },
                {
                    field: "NumRecipientLogins",
                    colId: "Shared",
                    //headerName: this.sf.localization['Creator'][0],
                    headerName: "Shared",
                },
                {
                    field: "NumSubscribed",
                    colId: "Subscribed",
                    //headerName: this.sf.localization['Frequency'][0],
                    headerName: "Subscribed",
                }
            ],
            defaultColDef: {
                cellClass: "d-flex align-items-center",
                filter: "agTextColumnFilter",
                suppressMenu: true
            },
            onGridReady: (params) => {
                if (this.dashboards) {
                    params.api.setGridOption('rowData', this.dashboards);
                }
                params.api.sizeColumnsToFit();
            },
            getRowId: ({ data: rowData }) => {
                return rowData.DashboardID;
            },
            onColumnVisible: (event) => {
                event.api.sizeColumnsToFit();
            },
            onGridSizeChanged: (event) => {
                event.api.sizeColumnsToFit();
            },
            /*onRowSelected: function (params) { // May be useful down the line, but for now, it's unnecessary
                params.data.isSelected = params.node.selected
            },*/
            rowSelection: 'multiple',
            rowMultiSelectWithClick: true,
            suppressCellFocus: true,
            suppressContextMenu: true,
            suppressDragLeaveHidesColumns: true
        };
        this.showGrid();
    };

    async showGrid() {
        let t = await this.dashboards;
        this.gridDashboardReady = true;
    }

    openDashboardAssignModal() {
        this.ownershipPopupOpen = true;
        this.linkedDataGroupLogins = [];

        for (let i = 0; i < this.listUsers.length; i++) {
            var user: User = this.listUsers[i];
            if (user.LoginID != this.selectedUserInfo.LoginID && user.RelatedGroupID == this.selectedUserInfo.RelatedGroupID)
                this.linkedDataGroupLogins.push(user);
        }

        this.gridOptionsDashboardsSelected = {
            columnDefs: [
                {
                    field: "DashboardName",
                    colId: "DashboardName",
                    headerName: "Dashboard Name",
                    width: 120
                },
                {
                    field: "DashboardGroup",
                    colId: "Folder",
                    headerName: "Folder",
                    width: 64
                },
                {
                    field: "NumRecipientLogins",
                    colId: "Shared",
                    headerName: "Shared",
                    width: 64
                },
                {
                    field: "NumSubscribed",
                    colId: "Subscribed",
                    headerName: "Subscribed",
                    width: 128
                }
            ],
            defaultColDef: {
                cellClass: "d-flex align-items-center",
                filter: "agTextColumnFilter",
                suppressMenu: true
            },
            onGridReady: (params) => {
                if (this.agGridOwned && this.agGridOwned.api)
                    params.api.setGridOption('rowData', this.agGridOwned.api.getSelectedRows());
                params.api.sizeColumnsToFit();
            },
            getRowId: ({ data: rowData }) => {
                return rowData.DashboardID;
            },
            onColumnVisible: (event) => {
                event.api.sizeColumnsToFit();
            },
            onGridSizeChanged: (event) => {
                event.api.sizeColumnsToFit();
            },
            /*onRowSelected: function (params) { // May be useful down the line, but for now, it's unnecessary
                params.data.isSelected = params.node.selected
            },*/
            suppressCellFocus: true,
            suppressRowClickSelection: true,
            suppressContextMenu: true,
            suppressDragLeaveHidesColumns: true
        };

        this.gridOptionsDashboardsAssign = {
            columnDefs: [
                {
                    field: "LoginName",
                    colId: "Username",
                    headerName: "Username",
                    width: 128
                },
                {
                    field: "ProfileName",
                    colId: "Role",
                    headerName: "Role",
                    width: 90
                },
                {
                    field: "RelatedGroupLevelName",
                    colId: "Level",
                    headerName: "Level",
                    width: 90
                },
                {
                    field: "RelatedGroupName",
                    colId: "Linked Data Group",
                    headerName: "Linked Data Group",
                    width: 128
                }
            ],
            defaultColDef: {
                cellClass: "d-flex align-items-center",
                filter: "agTextColumnFilter",
                suppressMenu: true
            },
            onGridReady: (params) => {
                if (this.linkedDataGroupLogins)
                    params.api.setGridOption('rowData', this.linkedDataGroupLogins);
                params.api.sizeColumnsToFit();
            },
            getRowId: ({ data: rowData }) => {
                return rowData.LoginID;
            },
            isExternalFilterPresent: () => {
                return this.filterValue.length > 0;
            },
            doesExternalFilterPass: (node) => {
                return this.gridHelperService.doesExternalFilterPass(node, this.filterValue);
            },
            onColumnVisible: (event) => {
                event.api.sizeColumnsToFit();
            },
            onGridSizeChanged: (event) => {
                event.api.sizeColumnsToFit();
            },
            localeText: {
                noRowsToShow: "<div class='px-4'>No users meet the requirement of sharing the same linked data group as the current owner.</div>"
            },
            /*onRowSelected: function (params) { // May be useful down the line, but for now, it's unnecessary
                params.data.isSelected = params.node.selected
            },*/
            rowSelection: 'single',
            suppressCellFocus: true,
            suppressContextMenu: true,
            suppressDragLeaveHidesColumns: true
        };

        this.gridModalReady = true;
    }

    changeOwnership() {
        let selectedDashboards: DashboardDTO[] = this.agGridOwned.api.getSelectedRows();
        let selectedDashboardIds: number[] = [];
        for (let i = 0; i < selectedDashboards.length; i++) {
            selectedDashboardIds.push(selectedDashboards[i].DashboardID);
        }

        let newOwner = this.agGridAssigned.api.getSelectedRows()[0];

        if (this.changeOwnershipSuccessful == true || this.changeOwnershipFailed == true || this.changeOwnershipTimer != null) { //check that the timer is not running and the toast message is closed before running
            this.changeOwnershipSuccessful = false;
            this.changeOwnershipFailed = false;

            if (this.changeOwnershipTimer != null) {
                clearTimeout(this.changeOwnershipTimer);
                this.changeOwnershipTimer = null;
            }
        }

        this.pendingOwnershipChangeName = newOwner.LoginName;

        this.uAService.changeDashboardOwnership(selectedDashboardIds, this.selectedUserInfo.LoginID, newOwner.LoginID).then(
            (response) => {
                this.closeDashboardAssignModal();
                this.changeOwnershipSuccessful = true;

                this.changeOwnershipTimer = setTimeout(() => {
                    this.changeOwnershipSuccessful = false;
                    this.changeOwnershipFailed = false;
                    this.changeOwnershipTimer = null;
                }, 5000);

                // Remove transferred dashboards from AG Grid
                for (let i = 0; i < selectedDashboards.length; i++) {
                    var index = this.dashboards.indexOf(selectedDashboards[i]);
                    this.dashboards.splice(index, 1);
                }
                this.agGridOwned.api.setGridOption('rowData', this.dashboards);
            },
            (error) => {
                this.closeDashboardAssignModal();
                this.changeOwnershipFailed = true;

                this.changeOwnershipTimer = setTimeout(() => {
                    this.changeOwnershipSuccessful = false;
                    this.changeOwnershipFailed = false;
                    this.changeOwnershipTimer = null;
                }, 5000);
            }
        );
    }

    closeDashboardAssignModal() {
        this.ownershipPopupOpen = false;
        this.gridOptionsDashboardsSelected = null;
        this.gridOptionsDashboardsAssign = null;
        this.gridModalDashboardsReady = false;
        this.gridModalLoginsReady = false;
    }

    applyFilter() {
        if (this.agGridAssigned.api)
            this.agGridAssigned.api.onFilterChanged();
    }

}
